import { KIDS } from 'constants/gender'
import { useContactDetails } from 'helpers/hooks/useContactDetails'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useObserver } from 'mobx-react-lite'
import texts from 'pages/Welcome/components/SeoText/texts'
import React, { FC } from 'react'
import { useConfigStore, useUserStore } from 'store/context'
import styled from 'styled-components'
import {
  bordersColor,
  darkGrayColor,
  primaryColor,
} from 'uiComponents/constants/colors'
import { fsXXS, fwBold } from 'uiComponents/constants/typography'

export const SeoText: FC = () => {
  const { t } = useTranslation()
  const userStore = useUserStore()
  const configStore = useConfigStore()
  const delivery = useObserver(() => configStore.deliveryDays)
  const serviceTime = useObserver(() => configStore.serviceTime)
  const userIsVip = useObserver(() => userStore.isVip)
  const gender = useObserver(() => userStore.gender)
  const { hotlineNumber } = useContactDetails(userIsVip)

  const textsCollection = texts(t, delivery, hotlineNumber, serviceTime)
  const genderWiseSeoText = gender !== KIDS ? textsCollection[gender] : []

  return (
    <SeoTextSection>
      {genderWiseSeoText.map(
        (text: { title: string; description: string }, index: number) => (
          <Article key={index}>
            <Headline>{text.title}</Headline>
            <Description>{text.description}</Description>
          </Article>
        ),
      )}
      <Description>
        *
        {t(
          'Kostenlos aus allen Netzen. Bei Anrufen aus dem Ausland können Gebühren anfallen.',
        )}
      </Description>
    </SeoTextSection>
  )
}

const SeoTextSection = styled.section`
  margin-top: 50px;
  border-top: 1px solid ${bordersColor};
  padding: 0 80px;
`

const Article = styled.article`
  margin: 30px auto 0;
  max-width: 1400px;
  &:first-child {
    margin-top: 50px;
  }
`

const Headline = styled.h2`
  font-size: ${fsXXS}px;
  ${fwBold};
  color: ${primaryColor};
`

const Description = styled.p`
  font-size: ${fsXXS}px;
  color: ${darkGrayColor};
  max-width: 1400px;
  margin: 0 auto;
`
